import { useCallback } from 'react';
import { useAnalyticsClient } from '../useAnalyticsClient';
import { useAnalyticsSession } from '../useAnalyticsSession';
import { useAnalyticsProperty } from '../useAnalyticsProperty';
import { UserActionPing } from 'rwl-shared/dist/models/analytics';
import { useAnalyticsTargetLayer } from '../useAnalyticsTargetLayer';
import { useAnalyticsTargetLayerArea } from '../useAnalyticsTargetLayerArea';

type PingEventProps = Omit<
    UserActionPing['data'],
    'targetLayer' | 'targetLayerId' | 'targetLayerArea'
>;

/**
 * Returns a function that, when called, sends a ping event to the BI service
 */
export const useAnalyticsPingEvent = () => {
    const { client } = useAnalyticsClient();
    const { session } = useAnalyticsSession();
    const { property } = useAnalyticsProperty();
    const { targetLayer, targetLayerId } = useAnalyticsTargetLayer();
    const { targetLayerArea } = useAnalyticsTargetLayerArea();

    return useCallback(
        (data: PingEventProps) => {
            if (!client || !session) {
                console.warn(
                    '[RWL] BI client or session is not available, event will be lost'
                );
                return;
            }

            client.createPingAction(session, property, {
                targetLayer,
                targetLayerId,
                targetLayerArea,
                ...data,
            });
        },
        [client, session, property, targetLayer, targetLayerId, targetLayerArea]
    );
};
